"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateXlsx2Csv2Config = void 0;
/* eslint-disable no-console */
/* eslint-disable camelcase */
const common_1 = require("@finley-technologies/common");
const uinode_1 = require("./operations/sanitize/uinode");
const uinode_2 = require("./operations/xlsx2csv/uinode");
const generateXlsx2Csv2Config = ({ sanitizeNode, xlsx2csvNode, }) => {
    (0, common_1.finleyAssert)(uinode_2.operation_xlsx2Csv.isNode(xlsx2csvNode), '!Xlsx2CsvOperation');
    (0, common_1.finleyAssert)(uinode_1.operation_sanitize.isNode(sanitizeNode), '!SanitizeOperation');
    const { baseFields, delimiter, doNotSanitizeFieldNames, } = sanitizeNode.configuration;
    console.log({
        mode: xlsx2csvNode.configuration.mode,
        baseFields,
        delimiter,
        doNotSanitizeFieldNames,
    });
    switch (xlsx2csvNode.configuration.mode) {
        case 'convertRange': {
            const { sheetName, headerRange, dataEndRange, importRaw, formula, } = xlsx2csvNode.configuration;
            if (!headerRange) {
                return {
                    config: null,
                    errors: ['No header range in xlsx2csv'],
                };
            }
            const importFormat = importRaw ? 'raw' : 'formatted';
            const xlsx2csvConfig = {
                operation: 'xlsx2csv2',
                mode: 'convertRange',
                sheetName,
                isSheetNameRegex: true,
                headerRange,
                dataEndRange,
                fields: baseFields.map((field) => ({
                    importFormat: formula ? 'formula' : importFormat,
                    ...field,
                })),
            };
            return {
                config: xlsx2csvConfig,
                errors: [],
            };
        }
        case 'extractValues': {
            const { extract } = xlsx2csvNode.configuration;
            const fields = extract.map((field) => {
                const { sheetName, fieldName, cellAddress, importRaw } = field;
                const importFormat = importRaw
                    ? 'raw'
                    : 'formatted';
                // find matching baseField from the baseFields definitions
                const baseField = baseFields.find((bf) => bf.field === fieldName);
                if (!baseField) {
                    console.log('no baseField found for fieldName', fieldName);
                    // this is not an error, its just that we have unused field from xlsx2csv.
                    return null;
                }
                return {
                    ...baseField,
                    sheetName,
                    isSheetNameRegex: true,
                    cell: cellAddress,
                    importFormat,
                };
            });
            const xlsx2csvConfig = {
                operation: 'xlsx2csv2',
                mode: 'extractValues',
                fields: fields.filter(common_1.typeguards.isNotNullOrUndefined),
            };
            return {
                config: xlsx2csvConfig,
                errors: [],
            };
        }
        default:
            return {
                config: null,
                errors: ['Invalid xlsx2csv mode'],
            };
    }
};
exports.generateXlsx2Csv2Config = generateXlsx2Csv2Config;
//# sourceMappingURL=generateXlsx2Csv2Config.js.map